import { render, staticRenderFns } from "./PageBadgeDetail.vue?vue&type=template&id=3d7edf2d&"
import script from "./PageBadgeDetail.vue?vue&type=script&lang=js&"
export * from "./PageBadgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageBadgeDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports